import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import toast from 'react-hot-toast';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (_) {
      toast.error('Something went wrong');
    } finally { setLoading(false); }
  };

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--navy)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '0 16px', fontFamily: 'Inter, sans-serif',
    }}>
      <div style={{ width: '100%', maxWidth: 380 }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <Link to="/" style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 8, marginBottom: 20 }}>
            <div style={{ width: 28, height: 28, borderRadius: 8, background: 'linear-gradient(135deg,#00D4AA,#0099FF)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:14 }}>⚡</div>
            <span style={{ fontWeight: 700, fontSize: 16, color: 'var(--text-1)' }}>Charge<span style={{ color: 'var(--teal)' }}>Sure</span></span>
          </Link>
          <h1 style={{ fontSize: 20, fontWeight: 700, color: 'var(--text-1)' }}>Reset Password</h1>
        </div>

        <div style={{ background: 'var(--slate)', border: '1px solid var(--border)', borderRadius: 16, padding: '28px 24px' }}>
          {sent ? (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 48, marginBottom: 12 }}>📧</div>
              <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>Check your inbox</h3>
              <p style={{ fontSize: 13, color: 'var(--text-3)', marginBottom: 20, lineHeight: 1.6 }}>
                If that email is registered, a reset link has been sent. It expires in 1 hour.
              </p>
              <Link to="/login" style={{ color: 'var(--teal)', fontSize: 13, textDecoration: 'none' }}>
                ← Back to login
              </Link>
            </div>
          ) : (
            <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              <p style={{ fontSize: 13, color: 'var(--text-3)', marginBottom: 4, lineHeight: 1.6 }}>
                Enter your email and we'll send a reset link.
              </p>
              <div>
                <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 5 }}>Email</label>
                <input
                  type="email" required placeholder="you@example.com"
                  value={email} onChange={e => setEmail(e.target.value)}
                  style={{ width: '100%', padding: '10px 12px', borderRadius: 8, background: 'var(--navy)', border: '1px solid var(--border-2)', color: 'var(--text-1)', fontSize: 14 }}
                />
              </div>
              <button type="submit" disabled={loading} style={{
                padding: '12px 0', borderRadius: 10, border: 'none',
                background: 'var(--teal)', color: 'var(--navy)',
                fontWeight: 700, fontSize: 14, cursor: 'pointer', opacity: loading ? 0.7 : 1,
              }}>
                {loading ? 'Sending…' : 'Send Reset Link'}
              </button>
              <Link to="/login" style={{ textAlign: 'center', color: 'var(--text-3)', fontSize: 13, textDecoration: 'none' }}>
                ← Back to login
              </Link>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
